export default "__VITE_ASSET__a8121740__"